import {
  Box,
  CircularProgress,
  InputAdornment,
  Paper,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";
import { Link, useSearchParams } from "react-router-dom";
import CustomDrawer from "../../../components/wrappers/CustomDrawer";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import ToggleDrawer from "../../../contexts/ToggleDrawer";
import { MASTER_SINGLE_CLINIC } from "../../../enums/UrlPaths";
import { useGetClinics } from "../../../hooks/useGetClinics";
import AddClinicForm from "./form/AddClinicForm";

export default function ClinicsPage() {
  const { t } = useTranslation();
  const { data: clinics, isLoading, error } = useGetClinics();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(
    searchParams.get("search") ?? ""
  );

  if (isLoading || clinics == null) {
    return (
      <Stack sx={{ width: "100%" }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (error) {
    return (
      <Box sx={{ width: "100%", textAlign: "center", color: "red" }}>
        {t("Error loading clinics")}
      </Box>
    );
  }

  const filteredClinics = clinics.filter((clinic) =>
    [
      clinic?.title,
      clinic?.streetAddress,
      clinic?.city,
      t(clinic?.country),
      clinic?.country,
    ].some((field) => field?.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <PageContentWrapper>
      <Stack spacing={2}>
        <Box>
          <ToggleDrawer>
            <CustomDrawer
              buttonMessage={t("AddClinic")}
              buttonSize={"large"}
              variant="contained"
              color="info"
              sx={{ mb: 2 }}
              testId="clinic.list.add"
            >
              <AddClinicForm />
            </CustomDrawer>
          </ToggleDrawer>
        </Box>
        <Paper
          sx={{
            p: 1,
          }}
        >
          <TextField
            sx={{ width: "100%" }}
            variant="standard"
            label={t("Search") + "..."}
            value={searchParams.get("search") ?? searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              searchParams.set("search", e.target.value);
              setSearchParams(searchParams);
            }}
            inputProps={{ "data-testid": "clinic.list.search-input" }}
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start">
                  <FaSearch />
                </InputAdornment>
              ),
            }}
          />
        </Paper>
        <Stack spacing={2}>
          {filteredClinics.map((clinic) => (
            <Link
              key={clinic?.id}
              to={MASTER_SINGLE_CLINIC + clinic?.title + "/" + clinic?.id}
            >
              <Paper
                sx={{
                  p: 1.5,
                }}
                className="Mui-blue-colored"
                data-testid={`clinic.list.row.${clinic?.id}`}
              >
                {`${clinic?.title}, ${clinic?.streetAddress}, ${
                  clinic?.city
                }, ${t(clinic?.country)}`}
              </Paper>
            </Link>
          ))}
        </Stack>
      </Stack>
    </PageContentWrapper>
  );
}
